import React from 'react';
import { ArrowRight, Mail, Eye, LineChart } from 'lucide-react';
import {Link} from "react-router-dom";

const ClientActions = ({ clientId, className, year = '2024' }) => {

    return (
        <div className={`flex flex-wrap gap-2 md:justify-end ${className ? className : ''}`}>
            <Link
                to={`/client-progress/${clientId}${year ? `?year=${year}`:''}`}
                className="inline-flex items-center justify-center gap-2 px-4 py-2
                    min-w-[140px] md:min-w-0
                    bg-indigo-500 dark:bg-indigo-600
                    text-white
                    text-sm
                    hover:bg-indigo-600 dark:hover:bg-indigo-700
                    rounded-md transition-colors"
            >
                Progress
                <LineChart className="w-4 h-4"/>
            </Link>
            <Link
                to={`/documents/${clientId}${year ? `?year=${year}`:''}`}
                className="inline-flex items-center justify-center gap-2 px-4 py-2
                    min-w-[140px] md:min-w-0
                    bg-indigo-500 dark:bg-indigo-600
                    text-white
                    text-sm

                    hover:bg-indigo-600 dark:hover:bg-indigo-700
                    rounded-md transition-colors"
            >
                Documents
                <Eye className="w-4 h-4"/>
            </Link>


            <Link
                to={`/view-letters/${clientId}${year ? `?year=${year}`:''}`}
                className="inline-flex items-center justify-center gap-2 px-4 py-2
                    min-w-[140px] md:min-w-0
                    bg-blue-500 dark:bg-blue-600
                    text-white
                    text-sm

                    hover:bg-blue-600 dark:hover:bg-blue-700
                    rounded-md transition-colors"
            >
                View Sent Letters
                <Mail className="w-4 h-4"/>
            </Link>
            <Link
                to={`/send-letter/${clientId}`}
                className="inline-flex items-center justify-center gap-2 px-4 py-2
                    min-w-[140px] md:min-w-0
                    text-sm

                    border border-red-500 dark:border-red-400
                    text-red-500 dark:text-red-400
                    hover:bg-red-50 dark:hover:bg-red-900/20
                    rounded-md transition-colors"
            >
                Send Letter
                <ArrowRight className="w-4 h-4"/>
            </Link>


        </div>
    );
};

export default ClientActions;
